import {LabelValue} from 'src/app/constants/general-constants';
import {Program} from 'src/app/model/cms-btv-core/program-model';
import {ContentMediaFilesRequest} from 'src/app/model/content-media-file-request.model';

export class UtilityModel {
  constructor(
    public id?: number,
    public message?: string,
    public func?: string,
    public quickFilter?: string,
    public vfoStatus?: string[],
    public pipe?: boolean,
    public labelValue?: LabelValue,
    public status?: string,
    public vfoFailed?: boolean,
    public contentType?: string,
    public program?: Program,
    public epgExternalId?: string,
    public seriesId?: string,
    public contentMediaFilesRequest?: ContentMediaFilesRequest,
  ) {}
}
